<template>
    <div>
        
       
        <v-data-table :headers="headers" :items="personas" class="elevation-1" hide-actions :loading="loading">
            <template v-slot:items="props">
                <td>{{ props.item.nombre_y_apellido }}</td>
                <td style="text-align: center;">{{ props.item.documento }}</td>
                <td>{{ props.item.fecha_inscripcion ? formatDate(props.item.fecha_inscripcion) : '' }}</td>
                <td>{{ props.item.modalidad }}</td>
                <td>

                    <v-btn depressed small :color="getColorEstado(props.item.status)">
                        {{ getNombreEstado(props.item.status)  }}
                    </v-btn>
            
                </td>
                <td>
                    <v-icon @click.stop="abrirValidacionFirma(props.item)" title="Ver" small>visibility</v-icon>
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script> 
import deslindesApi from '../../../../../api/deslindes'; 
import moment from 'moment';
 
export default {
    name: "ListaPersonasTabla",
    props: {
        evento_id: {
            type: Number,
            default: null 
        }
    },
    
    data() {
        return {
            filters: {
                query: '',
                documento: '',
                status: ''
            },
            loading: false,
            personas: [],
            headers: [
                {
                    text: 'Nombre y Apellido',
                    align: 'start',
                    sortable: false,
                    value: 'nombre', 
                },
                { text: 'Documento', value: 'documento', sortable: false, align: 'center' },
                { text: 'Fecha Inscripción', value: 'fecha_inscripcion', sortable: false, },
                { text: 'Modalidad', value: 'modalidad', sortable: false, },
                { text: 'Estado Deslinde', value: 'status', sortable: false, },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('DD/MM/YYYY');
        },
        loadData() {
            this.loading = true;
            const params = {};
            
            if (this.filters.query) {
                params.query = this.filters.query;
            }

            if (this.filters.documento) {
                params.documento = this.filters.documento;
            }
            if (this.filters.status) {
                params.status = this.filters.status;
            }
          
            deslindesApi.getDeslindes(this.evento_id,params)
                .then(response => {
                    this.personas = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.error("Error al cargar los deslindes:", error);
                });
        },
        applyFilters(filters) {
            this.filters = filters;
            this.loadData();
        },
        abrirValidacionFirma(persona) {
            console.log('Validar firma:', persona);
            this.$emit('validarFirma', persona);
        },
        getColorEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'orange';
                case 'APPROVED':
                    return 'green';
                case 'REJECTED':
                    return 'red';
                default:
                    return 'grey';
            }
        },

        getNombreEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'Pendiente';
                case 'APPROVED':
                    return 'Aprobado';
                case 'REJECTED':
                    return 'Rechazado';
                default:
                    return 'Desconocido';
            }
        },
        updateFilters(filters) {
            this.filters = filters;
            this.loadData();
        }    
    },
       
}
</script>

<style scoped>
/* Component styles can be added here */
</style>
